import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import Table from '../../components/common/Table';
import axios from 'axios';
import swal from 'sweetalert2';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const MobileMenuBtn = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: #1c1c1e;
    border-radius: 10px;
    color: #f5f5f7;
    cursor: pointer;
    flex-shrink: 0;
  }
`;

const Container = styled.div`
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  height: 94vh;
  overflow: scroll;
  width: 100%;
  margin: 16px 16px 16px 0;
  padding: 24px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04), 0 4px 20px rgba(0, 0, 0, 0.06);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    height: 100vh;
    margin: 0;
    border-radius: 0;
    padding: 16px;
    justify-content: flex-start;
  }
`;
const Button = styled.button`
  display: inline-block;
  width: 80px;
  height: 30px;
  background-color: #f5f5f7;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  border: none;
  color: #000;
  font-size: 15px;
  font-weight: 600;
  outline: none;
  cursor: pointer;
  :hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
`;
const CategoryDetailPage = () => {
  const [sub, setSub] = useState();
  const { name } = useParams();

  const getCategory = async () => {
    try {
      let { data: res } = await axios.get(`/admin/category/${name}`);
      if (res.length !== 0) {
        res.map((r) => {
          const id = r.subId;
          delete r.subId;
          r.modify = <Button onClick={() => _handleModify(id)}>변경</Button>;
          r.delete = <Button onClick={() => _handleDelete(id)}>삭제</Button>;
          return r;
        });
        setSub(res);
      } else {
        setSub(null);
      }
    } catch (e) {
      console.log(e, 'getList');
    }
  };

  const _handleModify = async (id) => {
    const { value: name } = await swal.fire({
      title: '변경할 이름을 입력해 주세요.',
      input: 'text',
      confirmButtonText: '확인',
      cancelButtonText: '취소',
      confirmButtonColor: '#232323',
      cancelButtonColor: '#a3a3a3',
      inputValue: '',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return '입력된 값이 없습니다.';
        }
      },
    });
    if (name) {
      try {
        const res = await axios.patch(`/admin/category/update/${id}`, {
          sub_category: name,
        });
        if (res.status === 200) {
          swal.fire({
            text: '변경이 완료되었습니다.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1000,
          });
          getCategory();
        }
      } catch (e) {
        swal.fire({
          width: 400,
          text: '오류가 발생했습니다.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1000,
        });
      }
    }
  };
  const _handleDelete = (id) => {
    swal
      .fire({
        title: '정말 카테고리를 삭제하시겠습니까?',
        text: '해당 카테고리의 모든 제품은 삭제됩니다.',
        icon: 'warning',
        iconColor: '#d33',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#a8a8a8',
        confirmButtonText: '확인',
        cancelButtonText: '취소',
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await axios.delete(`/admin/category/delete/${id}`);
            if (res.status === 200) {
              swal.fire({
                text: '제품 삭제가 완료되었습니다.',
                icon: 'success',
                showConfirmButton: false,
                timer: 1000,
              });
              getCategory();
            }
          } catch (e) {
            swal.fire({
              position: 'top-end',
              width: 400,
              text: '오류가 발생했습니다.',
              icon: 'error',
              showConfirmButton: false,
              timer: 1000,
            });
          }
        }
      });
  };
  const _handleCreate = async () => {
    const value = await swal.fire({
      title: '추가할 카테고리를 입력해 주세요.',
      input: 'text',
      confirmButtonText: '확인',
      cancelButtonText: '취소',
      confirmButtonColor: '#232323',
      cancelButtonColor: '#a3a3a3',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return '입력된 값이 없습니다.';
        }
      },
    });
    if (value) {
      try {
        const res = await axios.post(`/admin/category/${name}`, {
          sub_category: value.value,
        });
        if (res.status === 200) {
          swal.fire({
            text: '성공적으로 추가되었습니다.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1000,
          });
          getCategory();
        }
      } catch (e) {
        swal.fire({
          width: 400,
          text: '오류가 발생했습니다.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1000,
        });
      }
    }
  };

  const titles = ['카테고리', '이름 변경', '카테고리 삭제'];

  useEffect(() => {
    getCategory();
  }, []);

  const button = (
    <Button
      style={{ width: '80px', height: '40px', backgroundColor: '#a3a3a3' }}
      onClick={() => _handleCreate()}
    >
      추가
    </Button>
  );

  return (
    <Container>
      <div style={{ width: '100%', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 10 }}>
        <MobileMenuBtn onClick={() => window.dispatchEvent(new Event('open-sidebar'))}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </MobileMenuBtn>
        <h2 style={{ fontSize: 20, fontWeight: 700, color: '#111827', margin: 0 }}>카테고리 조회</h2>
      </div>
      {sub ? (
        <Table
          caption="카테고리 조회"
          titles={titles}
          data={sub}
          button={button}
        />
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <h2>
            해당 제조사에 카테고리가 존재하지 않습니다. 새로 생성하시겠습니까?
          </h2>
          <Button onClick={() => _handleCreate()}>생성</Button>
        </div>
      )}
    </Container>
  );
};

export default CategoryDetailPage;
